'use es6';

import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import { jsx as _jsx } from "react/jsx-runtime";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import spiderweb from 'bender-url!../../../img/spiderweb-corner.png';
import { TabletAndBelow } from '../themes/mixins';
var UpperLeft = styled.div.withConfig({
  displayName: "SpiderWebs__UpperLeft",
  componentId: "sc-1soiw0f-0"
})(["transform:rotate(270deg);position:absolute;height:200px;width:auto;left:-20px;opacity:0.2;z-index:100;"]);
var UpperRight = styled.div.withConfig({
  displayName: "SpiderWebs__UpperRight",
  componentId: "sc-1soiw0f-1"
})(["position:absolute;height:200px;width:auto;right:0;top:-10px;opacity:0.2;", ""], TabletAndBelow(_templateObject()));
export var SpiderWebLeft = function SpiderWebLeft() {
  return /*#__PURE__*/_jsx(UpperLeft, {
    children: /*#__PURE__*/_jsx("img", {
      src: spiderweb
    })
  });
};
export var SpiderWebRight = function SpiderWebRight() {
  return /*#__PURE__*/_jsx(UpperRight, {
    children: /*#__PURE__*/_jsx("img", {
      src: spiderweb
    })
  });
};